import React, { useEffect } from 'react';
import './featured.scss';
import CustomTitle from '../../components/UI/title/CustomTitle';
import { useDispatch, useSelector } from 'react-redux';
import { setButtonClick, setIconButton, setIsShowButton, setTextButton } from '../../store/buttonSlice';
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import { setButtonClickNot, setIconButtonNot, setIsShowButtonNot, setTextButtonNot } from '../../store/buttonNotSlice';
import FeaturedContent from './FeaturedContent';
import PageContent from '../../components/PageContent/PageContent';
import useMixpanel from '../../hooks/useMixpanel';

const VideoQuote = ({ id }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const buttonClicked = useSelector((state) => state.button.buttonClicked);
    const buttonNotClicked = useSelector((state) => state.buttonNot.buttonClicked);
    const nextPage = useSelector((state) => state.appRoute.nextPage);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { trackP1Event } = useMixpanel();
    const eventNames = ['onboarding_video_quote', 'onboarding_static_quote', 'onboarding_ad_quote'

    ];
    useEffect(() => {
        if (buttonClicked) {
            dispatch(setButtonClick(false));
            trackP1Event(eventNames[id], {
                user_response:  'I agree'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonClicked, dispatch]);

    useEffect(() => {
        if (buttonNotClicked) {
            dispatch(setButtonClickNot(false));
            trackP1Event(eventNames[id], {
                user_response:  'Not sure'
            })
            history.push({
                pathname: nextPage,
                search: `?${queryParams.toString()}`
            });
        }
    }, [buttonNotClicked, dispatch]);

    useEffect(() => {
        dispatch(setIsShowButton(true));
        dispatch(setTextButton('I agree'));
        dispatch(setIconButton('Tick'));
        dispatch(setIsShowButtonNot(false))

        dispatch(setIsShowButtonNot(true));
        dispatch(setTextButtonNot('Not sure'));
        dispatch(setIconButtonNot('not'));
    }, []);


    const titles = [
        'Do you agree with the following statement?',
        'Do you agree with<br>the following statement?',
        'Do you agree with<br>the following statement?'
    ]
    return (
        <div className="page">
            <PageContent>
                <div className="page-content">
                    <CustomTitle
                        style={{ marginBottom: '24rem' }}
                        title={titles[id]}
                    />
                    <FeaturedContent VideoQuote={true} id={id} />

                </div>
            </PageContent>
        </div>
    );
};

export default VideoQuote;
